"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sudoku =
/*#__PURE__*/
function () {
  /**
   * Constructs a sudoku with the optional initial values
   * 
   * @param {Array<{cell: number, number:number}>} initials 
   */
  function Sudoku() {
    var _this = this;

    var initials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Sudoku);

    _defineProperty(this, "board", void 0);

    _defineProperty(this, "immutable", void 0);

    this.board = new Array(81).fill(0);
    this.immutable = initials;
    initials.forEach(function (initial) {
      _this.board[initial.cell] = initial.number;
    });
  }
  /**
   * @param {String} board
   */


  _createClass(Sudoku, [{
    key: "setBoard",
    value: function setBoard(board) {
      this.board = board;
    }
    /**
     * @param {number} i
     * @returns {number} the number at place i in sudoku
     */

  }, {
    key: "get",
    value: function get(i) {
      if (i < 0 || i > 80) return 0;
      return this.board[i];
    }
  }, {
    key: "set",
    value: function set(i, number) {
      if (i < 0 || i > 89) return;
      if (number < 0 || number > 9) return;
      if (this.getImmutableCells().includes(i)) return;
      this.board[i] = number;
    }
  }, {
    key: "getImmutableCells",
    value: function getImmutableCells() {
      return this.immutable.map(function (initial) {
        return initial.cell;
      });
    }
  }, {
    key: "isImmutableCell",
    value: function isImmutableCell(cell) {
      return this.getImmutableCells().includes(cell);
    }
  }, {
    key: "addInitial",
    value: function addInitial(cell, number) {
      this.set(cell, number);
      this.immutable.push({
        cell: cell,
        number: number
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      this.board = new Array(81).fill(0);
      this.immutable.forEach(function (initial) {
        _this2.board[initial.cell] = initial.number;
      });
    }
  }, {
    key: "copy",
    value: function copy() {
      var newSudoku = new Sudoku();
      newSudoku.immutable = this.immutable.slice();
      newSudoku.board = this.board.slice();
      return newSudoku;
    }
  }, {
    key: "isFull",
    value: function isFull() {
      return !this.board.includes(0);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.board.some(function (cell) {
        return cell !== 0;
      });
    }
  }]);

  return Sudoku;
}();

var _default = Sudoku;
exports["default"] = _default;